import React__default from 'react';
import classnames from 'classnames';
import { SelectionBoxRadio } from '@grandvisionhq/fun-products';
import { StockIndicator } from '@grandvisionhq/inventory';
import { useIntl } from '@grandvisionhq/state';

const VariantPicker = ({ variantItems , activeVariantSku , activeVariantLabel: activeVariantLabelProp , stockCount , isAllowBackOrder , enableStockIndicator , channelAvailability , formatProductUrl , onPick  })=>{
    var ref;
    const { getFormattedLabel , getLabel  } = useIntl();
    const activeVariantLabel = activeVariantLabelProp !== null && activeVariantLabelProp !== void 0 ? activeVariantLabelProp : (ref = variantItems.find((v)=>v.sku === activeVariantSku
    )) === null || ref === void 0 ? void 0 : ref.description;
    const queryString = typeof window !== 'undefined' ? window.location.search : '';
    const labels = {
        title: getFormattedLabel('products.numberOfVariants', {
            labelData: {
                number: variantItems.length
            }
        }),
        screenreaderDefault: getLabel('products.variant.description.screenreader.fallback')
    };
    const stockIndicator = enableStockIndicator ? /*#__PURE__*/ React__default.createElement(StockIndicator, {
        stockCount: stockCount,
        allowBackOrder: isAllowBackOrder,
        channelAvailability: channelAvailability
    }) : null;
    if (!variantItems.length) {
        return null;
    }
    if (variantItems.length === 1) {
        return /*#__PURE__*/ React__default.createElement("div", {
            className: "variant-picker"
        }, /*#__PURE__*/ React__default.createElement("div", {
            className: "variant-picker__header"
        }, activeVariantLabel && /*#__PURE__*/ React__default.createElement("div", {
            className: "variant-picker__info"
        }, activeVariantLabel), stockIndicator));
    }
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "variant-picker"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "variant-picker__header"
    }, /*#__PURE__*/ React__default.createElement("strong", {
        id: "variants-label"
    }, labels.title), stockIndicator), /*#__PURE__*/ React__default.createElement("div", {
        className: "variant-picker__info"
    }, activeVariantLabel), /*#__PURE__*/ React__default.createElement("div", {
        className: "variant-picker__variants",
        role: "radiogroup"
    }, variantItems.map((variant)=>{
        const { sku , imageUrl , slug , description , productType  } = variant;
        const accessibleName = description || `${sku} - ${labels.screenreaderDefault}`;
        const variantUrl = formatProductUrl({
            sku,
            slug,
            productType
        });
        const href = `${variantUrl}${queryString}`;
        return /*#__PURE__*/ React__default.createElement(SelectionBoxRadio, {
            // Only enable tab stop on the active variant
            // Arrow keys can be used to move between the different radio buttons
            tabIndex: activeVariantSku === sku ? 0 : -1,
            "aria-labelledby": "variants-label",
            checked: activeVariantSku === sku ? true : false,
            key: sku,
            title: accessibleName,
            name: "variant",
            className: classnames('variant-picker__variant', {
                'variant-picker__variant--active': activeVariantSku === sku
            }),
            onChange: ()=>onPick(variant, href)
        }, /*#__PURE__*/ React__default.createElement("a", {
            href: href,
            "data-t": "variant-picker-button",
            // user will tab-stop on the radio buttons of the SelectionBoxRadio
            tabIndex: -1,
            onClick: (event)=>onPick(variant, href, event)
        }, /*#__PURE__*/ React__default.createElement("img", {
            src: `${imageUrl}?q=70&w=62&h=36&fit=fill&fm=jpeg`,
            alt: accessibleName
        })));
    })));
};

export { VariantPicker };
//# sourceMappingURL=VariantPicker.js.map
